// GC64 · MP-10 · Feb 16, 2026 — Timezone-safe display helper.
//
// Backend emits ISO strings with `+00:00` UTC offset (Motor client
// `tz_aware=True`, see backend/core.py). Frontend converts to the
// user's civil time via `Intl.DateTimeFormat`.
//
// For LIVE (UK-only product) we PIN `Europe/London` so:
//   • BST (UTC+1) in summer months is applied automatically.
//   • GMT (UTC+0) in winter months is applied automatically.
//   • DST transitions on the last Sunday of March / October
//     resolve to the correct civil hour via the browser's IANA
//     tz database — no `+1`-style constants anywhere.
//
// Regression pins live in
// src/pages/__tests__/UploadHistory.timezone.test.jsx.

export const TIME_ZONE = "Europe/London";

/** Format an ISO date string for user-facing display.
 *
 * Empty / null / undefined → empty string (no crash).
 * Invalid ISO → the original string (no crash).
 */
export function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-GB", {
      timeZone: TIME_ZONE,
      day: "numeric", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

/** Return "YYYY-MM-DD" for the Europe/London civil date of the
 * given Date object. Used by history bucketing so a 23:30 UK
 * upload never rolls into "yesterday" when its underlying UTC
 * hour crosses midnight. */
export function londonYMD(d) {
  try {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: TIME_ZONE,
      year: "numeric", month: "2-digit", day: "2-digit",
    }).formatToParts(d);
    const g = (t) => parts.find((p) => p.type === t)?.value || "";
    return `${g("year")}-${g("month")}-${g("day")}`;
  } catch {
    return d.toISOString().slice(0, 10);
  }
}
